import styled from "styled-components";

export const CircleSvg = styled.svg`
  animation: spin 1s linear infinite;
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
`;
